'use client'

import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { useUserInboxMarkAllAsRead } from '@repo/services'
import { Button, Icon, Row, Typography } from '@repo/ui/components'

export const MessagesCTA = ({ origin }: { origin: 'layout' | 'container' }) => {
  const { t } = useTranslate()

  const { mutate: markAllAsRead } = useUserInboxMarkAllAsRead({
    invalidate: true,
  })
  return (
    <Row
      className={`${origin === 'layout' ? 'sticky top-0' : 'items-center justify-between'}  bg-neutral-surface-light p-xs md:p-0 gap-xs`}
    >
      {origin === 'layout' && (
        <ButtonLink
          variant='transparent'
          size='md'
          color='neutral'
          href='/profile'
          aria-label='Back to Profile'
          endIcon={<Icon name='ArrowRightLine' size='md' />}
        />
      )}

      <Typography size='md' weight='bold'>
        {t('profileMessagesPage_title')}
      </Typography>

      {origin !== 'layout' && (
        <Button
          variant='transparent'
          size='sm'
          color='base'
          onClick={() =>
            markAllAsRead({
              until: new Date().toISOString(),
            })
          }
        >
          {t('profileMessagesPage_read_all_messages')}
        </Button>
      )}
    </Row>
  )
}
